import {
  IsString,
} from 'class-validator';

export class TocDto {
  @IsString()
  toc: string;
};
